import { render } from "./SVGLoader.vue?vue&type=template&id=ade48fc4&ts=true"
import script from "./SVGLoader.vue?vue&type=script&lang=ts"
export * from "./SVGLoader.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__